import useSWR from 'swr';

export const useFleetDetails = (id) => useSWR(id ? `fleets/${id}` : null);
